module.exports = __webpack_public_path__ + "ua.svg?223ace875e96cae59950f636f583b196";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ua.svg
// module id = 1156
// module chunks = 27